import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {WorkflowPositionView} from '../../../models/position.models';

@Component({
    selector: 'position-readonly-box',
    templateUrl: './position-readonly-box.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PositionReadonlyBoxComponent {
  @Input() positions: WorkflowPositionView[];

  constructor() {
  }
}
